export const modalStyles = {
  button: {
    margin: '10px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageContainer: {
    padding: '0 30px',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '400px',
    borderRadius: '10px',
  },
}
